import { render, staticRenderFns } from "./BuyPackage.vue?vue&type=template&id=4f561337&"
import script from "./BuyPackage.vue?vue&type=script&lang=js&"
export * from "./BuyPackage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports